// @flow
import tinycolor from 'tinycolor2'

// Types
export type Props = {
  $palette: Function,
  $active?: Boolean,
  $indicatorColor: string,
  $tabColor: string,
  $activeTabColor: string,
  $mobile?: Boolean,
}

export const TabsContainer = {
  userSelect: 'none',
  display: 'flex',
  minHeight: '45px',
  flexShrink: 0,
  borderBottom: '1px solid #eee',
}

export const TabContainer = ({
  $palette,
  $active,
  $indicatorColor,
  $tabColor,
  $activeTabColor,
  $mobile,
}: Props) => {
  const indicatorColor = $palette($indicatorColor || 'primary')
  const tabColor = $palette($tabColor || 'TRANSPARENT')
  const activeTabColor = $palette($activeTabColor || 'TRANSPARENT')

  return {
    padding: '5px 8px 8px 8px',
    outline: 'none',
    ':not(:last-child)': {
      marginRight: '1px',
    },
    ':focus': $active
      ? {}
      : {
          borderTop: `3px solid ${indicatorColor.clone().setAlpha(0.3)}`,
        },
    ':hover': $active
      ? {}
      : {
          borderTop: `3px solid ${indicatorColor.clone().setAlpha(0.3)}`,
        },
    display: 'flex',
    flex: 1,
    zIndex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: $mobile ? 'column' : 'row',
    textAlign: $mobile ? 'center' : 'inherit',
    color:
      activeTabColor.toString() !== $palette('TRANSPARENT').toString()
        ? tinycolor
            .mostReadable(activeTabColor, [tabColor], {
              includeFallbackColors: true,
            })
            .toString()
        : $palette('BLACK').toString(),
    borderTop: $active
      ? `3px solid ${indicatorColor}`
      : '3px solid transparent',
    cursor: 'pointer',
    backgroundColor: $active ? `${activeTabColor}` : `${tabColor}`,
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  }
}

export const TabIcon = {
  margin: '0 8px',
  fontSize: '18px',
}
